<small
    *ngIf="errorMessage !== null"
    class="p-error flex justify-content-start text-left"
    [style]="'margin-bottom: 10px; margin-left: 5px;' + style"
    >{{ errorMessage }}</small
  >
